import React from 'react';
import classNames from 'classnames';
import './index.less';

const ListCard = ({ className, children }) => {
    return <div className={classNames('list-card', className)}>{children}</div>;
};

export default ListCard;
